import React from 'react';
import PropTypes from 'prop-types';

const FlyerToast = ({ url, name, closeToast, onRead }) => {
  FlyerToast.propTypes = {
    url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    closeToast: PropTypes.func.isRequired,
    onRead: PropTypes.func.isRequired
  };

  const close = (isRead = false) => {
    onRead(isRead);
    closeToast();
  };

  return <div className='flyer-toast'>
    <div className='link-container'>
      <span>{name}</span>
    </div>
    <div className='flyer-buttons'>
      <a className='btn btn-link btn-link-blue' onClick={() => close(true)}>Read</a>
      <a className='btn btn-link' onClick={() => close(false)}>Close</a>
    </div>
  </div>;
};

export default FlyerToast;
